export enum AffectedDevicesWarning {
    DuplicateSerials = 'duplicateSerialNumbers',
    StagesDontUpdateAll = 'stagesDoNotUpdateAllDevicesInGlobalFilters',
};